import api from '~/api/Endpoints';
import { HEADER_USER_UUID } from '~/scripts/constants';
import type { Filters } from '~/types/filters';
import type { Searches } from '~/types/searches';

export const getDownloads = async () => {
  return api.get('/downloads');
};

export interface PostDownloadBody {
  user: string;
  search: Searches.StoredSearchObject;
  /** {name: id} */
  columns: Record<string, string>;
  total: number;
  rows: number;
  filters: Filters.Filters;
  /** recaptcha token */
  re: string | undefined;
}

export interface PostDownloadResponse {
  error: string;
  created_at: string;
  completed_at: string;
  file: string;
  hash: string;
}
export const postDownload = async (body: PostDownloadBody) => {
  return api.post('/downloads', {
    body,
    headers: {
      [HEADER_USER_UUID]: body.user,
    },
  });
};

export const getDownloadsHash = async (hash: string) => {
  return api.get(`/downloads/:hash`, {
    params: { hash },
  });
};
